document.querySelectorAll('.header__inline-menu details').forEach((detail) => {
  detail.addEventListener('mouseover', () => {
    detail.setAttribute('open', '');
  });
  detail.addEventListener('mouseleave', () => {
    detail.removeAttribute('open');
  });
});
document.querySelectorAll('.header__inline-menu details summary').forEach((summary) => {
  summary.addEventListener('click', (event) => {
    // If the menu is already open, a second click will follow the link
    if (summary.parentElement.hasAttribute('open')) {
      const link = summary.closest('details').querySelector('a'); // Or put a specific URL here
      if (link) window.location.href = link.href;
    }
  });
});